import React from 'react';

import classNames from 'classnames';

import './index.scss';

const RadioToggle = ({ component: Component = 'div', ...props }) => (
  <Component {...props} className={classNames('radio-toggle', props.className)}>
    {props.children}
  </Component>
);

export default RadioToggle;
